import { PublicLegalShell } from "@/components/legal/PublicLegalShell";
import { LegalDocumentCard } from "@/components/legal/LegalDocumentCard";
import { LEGAL_DOCUMENTS } from "@/content/legal";

export default function MentionsLegalesPage() {
  return (
    <PublicLegalShell>
      <LegalDocumentCard doc={LEGAL_DOCUMENTS["mentions-legales"]} />
    </PublicLegalShell>
  );
}
